<template>
  <div class="container-fluid">
    <Cards />
    <div class="row">
      <div class="col-md-9">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>Latest Transactions</h2>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>

        <div class="tablesurround">
          <table width="100%" border="0">
            <tbody>
              <tr class="thead">
                <th
                  scope="col"
                  width="55px;"
                  class="colAmt"
                  style="text-align: left; padding-left: 10px"
                >
                  Amount
                </th>
                <th
                  scope="col"
                  width="40px;"
                  class="colDate"
                  style="text-align: center; text-indent: -10px"
                >
                  Date
                </th>
                <th
                  scope="col"
                  width="392px;"
                  class="colTrans"
                  style="text-align: left; text-indent: -5px"
                >
                  Transaction details
                </th>
                <th
                  scope="col"
                  width="121px;"
                  class="colBal"
                  style="text-align: right; padding-right: 30px"
                >
                  Balance
                </th>
              </tr>
            </tbody>
          </table>
          <div
            v-if="isDashboardTransactionsGridLoading === true"
            class="tablesurroundinner"
          >
            <div class="d-flex justify-content-center" style="margin-top: 10px">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div
            v-if="isDashboardTransactionsGridLoading === false"
            class="tablesurroundinner"
          >
            <table width="100%" border="0">
              <tbody
                v-for="transaction of latestTransaction"
                :key="transaction.id"
              >
                <tr>
                  <td class="colAmt">
                    <span class="amt">{{
                      "-" +
                        transaction.currency +
                        transaction.amountInCardCurrency.toFixed(2)
                    }}</span>
                    <span class="time">{{ transaction.timeDisplay }}</span>
                  </td>
                  <td class="colDate">
                    <div class="date">
                      <span class="datenum">{{ transaction.dayDisplay }}</span
                      ><span class="dateday">{{
                        transaction.dayOfWeekDisplay
                      }}</span>
                    </div>
                  </td>
                  <td class="colTrans">
                    <div class="transText">
                      {{ transaction.description }}
                    </div>
                    <div class="transLabels">
                      <span class="transLabel">{{
                        transaction.typeDisplay
                      }}</span>
                      <span
                        class="transLabel"
                        v-if="transaction.feeInCardCurrency > 0"
                        >{{ transaction.feeDisplay }}</span
                      >
                    </div>
                  </td>
                  <td class="colBal current">
                    <span class="figures"
                      ><strong></strong> £{{
                        transaction.balance.toFixed(2)
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
              <tbody
                v-if="
                  latestTransaction !== undefined &&
                    latestTransaction.length === 0
                "
              >
                <td
                  style="
                    display: flex;
                    justify-content: center;
                    margin-top: 11px;
                  "
                >
                  No transactions to display
                </td>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tablesurround mobtable">
          <table width="100%" border="0">
            <tbody>
              <tr class="thead">
                <th
                  scope="col"
                  width="55px;"
                  class="colAmt"
                  style="text-align: left; padding-left: 10px"
                >
                  Amount
                </th>
                <th
                  scope="col"
                  width="40px;"
                  class="colDate"
                  style="text-align: center; text-indent: -10px"
                >
                  Date
                </th>
                <th
                  scope="col"
                  width="121px;"
                  class="colBal"
                  style="text-align: right; padding-right: 30px"
                >
                  Balance
                </th>
              </tr>
            </tbody>
          </table>

          <template v-if="isDashboardTransactionsGridLoading === false">
            <div
              v-for="transaction of latestTransaction"
              v-bind:key="transaction.id"
              class="tablesurroundinner"
            >
              <table width="100%" border="0">
                <tbody>
                  <tr>
                    <td class="colAmt">
                      <span class="amt">{{
                        "-" +
                          transaction.currency +
                          transaction.amountInCardCurrency.toFixed(2)
                      }}</span>
                      <span class="time">{{ transaction.timeDisplay }}</span>
                    </td>
                    <td class="colDate">
                      <div class="date">
                        <span class="datenum">{{ transaction.dayDisplay }}</span
                        ><span class="dateday">{{
                          transaction.dayOfWeekDisplay
                        }}</span>
                      </div>
                    </td>
                    <td class="colBal current">
                      <span class="figures"
                        ><strong></strong> £{{
                          transaction.balance.toFixed(2)
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="transText">
                {{ transaction.description }}
              </div>
              <div class="transLabels">
                <span class="transLabel">{{ transaction.typeDisplay }}</span>
                <span
                  class="transLabel"
                  v-if="transaction.feeInCardCurrency > 0"
                  >{{ transaction.feeDisplay }}</span
                >
              </div>
            </div>
          </template>
          <template
            v-if="
              isDashboardTransactionsGridLoading === false &&
                latestTransaction !== undefined &&
                latestTransaction.length === 0
            "
          >
            <div class="tablesurroundinner">
              <table width="100%" border="0">
                <tbody>
                  <td
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 11px;
                    "
                  >
                    No transactions to display
                  </td>
                </tbody>
              </table>
            </div>
          </template>
          <template>
            <div
              v-if="isDashboardTransactionsGridLoading === true"
              class="tablesurroundinner"
              style="padding-top: 10px"
            >
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="col-md-3 promos">
        <Promotions />
      </div>
      <div class="col-md-3 promos promos2">
        <Promotions />
      </div>
    </div>
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import routes from "@/constants/routes";
import actions from "@/store/cards/actions";
import Promotions from "./Promotions.vue";
import Cards from "./Cards.vue";

export default {
  components: {
    Promotions,
    Cards
  },
  created() {
    this.myVehicle = routes.MYVEHICLE;
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
  },
  beforeMount() {
    this.isDashboardTransactionsGridLoading = true;
    this.$store.dispatch(actions.FETCH_LATEST_TRANSACTIONS);
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    latestTransaction: {
      get() {
        return this.$store.state.cards.latestTransactions;
      }
    },
    isDashboardTransactionsGridLoading: {
      get() {
        return this.$store.state.settings.isDashboardTransactionsGridLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsDashboardTransactionsGridLoadingMutation",
          value
        );
      }
    }
  }
};
</script>
